export default __webpack_public_path__ + "static/media/R3.fba21a1b.PNG";